module.exports = {
  normal: {
    nodata: 'Data no found',
  },
  succ: {
    normal: 'Success',
  },
  login: {
    login: 'GitHub Login',
    service_tip: 'Please check agree the terms of service',
  },
  index: {
    avatar: 'Avatar',
    nav: {
      home: 'Home',
      btnAriaLabel: 'Drop down button',
      account: 'Account',
      settings: 'Settings',
      about: 'About',
      signOut: 'Log out',
      feedback: 'Feedback',
    },
    updateBtn: 'Sync',
    signOutConfirm: 'Confirm logout?',
    finishUpdate: 'Synchronization complete',
    updateErr: 'Something went wrong😿, please try again later',
    list: {
      allProject: 'All',
      overview: 'Overview',
      recommend: 'Recommendation',
      explore: 'Explore',
      myCollections: 'My categories',
      githubCollections: 'GitHub default categories',
      allStars: 'All Stars',
      starWithoutCollect: 'Uncategorized',
      loadingText: 'Loading Stars...',
      starsDel: 'Trash',
    },
  },
  sortList: {
    byTime: 'Date added',
    byName: 'Name(A-Z)',
    byNum: 'Num',
    bySartNum: 'Most starred',
    byForkNum: 'Most forked',
    byVisitTime: 'Most visited',
    byLikeNum: 'Most liked',
  },
  starsPanel: {
    eidtCollectionAria: 'Edit category',
    search: 'Enter keyword...',
    backAria: 'back',
    loadingText: 'Loading Stars...',
    copySucc: 'Copied',
    copyManual: 'Ctrl/Command + C to copy',
    editTip: 'Edit success!',
    serverErr: 'Something went wrong😿, please try again latter',
    unStarTip: 'Unstar success',
    delTrashStar: 'Delete Success',
    multiDelConfirm: 'Delete {num} project?',
    delConfirm: 'Delete 「{name}」',
    unstarCofirm: 'Unstar this project?',
    unstarConfirm: 'Unstar 「{name}」?',
    multiUnstarConfirm: 'Unstar {num} projects?',
    starConfirm: 'Star 「{name}」?',
    multiStarConfirm: 'Star {num} projects?',
    noSelect: 'No project selected',
    toolbarUnstar: 'UnStar',
  },
  editPanel: {
    titleEdit: 'Edit category',
    titleAdd: 'Add category',
    myCollections: 'My categories',
    recommend: 'Recommended category name',
    inputTip: 'Select or create new category',
    inputPlaceholder: 'Enter category name...',
    inputwAria: 'focus',
    createNewTag: 'Create {name} category',
    githubTagTip: 'GitHub default category',
  },
  noProjectTip: 'No Repos',
  accessToken: {
    title: 'Access token needed',
    tip_1: 'More GitHub permissions needed. Please initialize a new GitHub access token, which will be kept locally.',
    tip_2: 'How to generate token? See more info.',
    tip_3: 'Generate access token.',
    btn: 'Save token',
    inputTip: 'Please input token',
    saveTip: 'Token has been saved, your can edit it in the setting panel🔧',
    errTip: 'GitHub access token may not config right or need higher permission. Please check in setting panel.',
    errTip_404: 'Project not found or GitHub access denied',
  },
  settingPanel: {
    accessTokenInput: 'Please enter token',
    tokenTip: 'Set GitHub access token🔑  to release more feature,',
    tokenLink: 'see more information.',
    tokenSetSucc: 'Access token has been updated',
    panelSize: 'Appearance',
    panelSizeBig: 'Big',
    panelSizeSmall: 'Small',
    theme: 'Theme',
    themeWhite: 'White',
    themeDark: 'Dark',
    email: 'Email',
    emailBtn: 'Change email',
    autoBackUp: 'Auto backup',
    backUpBtn: 'Backup now',
    backTip: 'Backup will be sent every Sunday',
    noEmailTip: 'Mail is not set yet, set up now？',
    language: 'language',
    langEn: 'English',
    langCn: 'Chinese(Simplified)',
    sendEmailTip: 'Backup had send to',
    sendEmailTip_2: 'Email may be delayed for minutes',
    hotKeys: 'Hotkeys',
  },
  profile: {
    acAccountType: 'Account type',
    memberSince: 'Member Since',
    upgradeBtn: 'Upgrade to PRO',
    upgradeBtn2: 'Renew Now',
    autoRenew: 'Auto-renewal',
    subscribe: 'Manage subscription ',
    subscribeCancel: 'Subscription canceled',
    paymentTip: 'Have payment issue? Please contact service@littlestarcloud.com',
  },
  emailPanel: {
    editBtn: 'Edit email address',
    placeholder: 'Email address',
    verifyBtn: 'Verify',
    cancelBtn: 'Cancel',
    sendTip: 'A verification email was sent to',
    reSendTip: 'No received？Send agian.',
    varifyUpdate: 'Update user data now',
    updateSucc: 'Update Success',
    emailVarifyErr: 'Invalid email format',
    emailReqSuccTip: 'A verification email was sent to you email address',
  },
  iconPanel: {
    title: 'Choose a icon set',
    title2: 'Choose a Icon',
    noIconSet: 'No data',
    noIcon: 'No data',
  },
  feedback: {
    placeholder1: 'Please enter email address',
    placeholder2: 'Please enter your feedback',
    btn: 'Submit',
    succ: "Thank you for your feedback, We'll be in touch!",
    back: 'back',
    emailErr: 'Invalid email format',
    conErr: 'Please enter feedback!',
  },
  pay: {
    succText1: 'Success! ',
    succText2: 'Thank you for the support!',
    btn: 'Confirm',
    checking: 'Waiting payment complete...',
    err: 'Have payment issue?Please contact service@littlestarcloud.com',
    notDone: 'Payment not completed',
  },
  detail: {
    noReadme: 'No README',
    updatingText: 'Loading stars...',
  },
  c_toast: {
    btn: 'Confirm',
    btnCancel: 'Cancel',
  },
  about: {
    slogen: 'A GitHub stars management tool',
  },
  toolbar: {
    categoryNameIvalid: 'Please enter category name',
    editsucc: 'Edit success',
    delTip: 'Delete this category?',
    delSucc: 'Success',
  },
  trend: {
    selectDatePlaceHolder: 'Date range',
    selectLangPlaceHolder: 'Language',
    allLang: 'All language',
    daily: 'Today',
    weekly: 'This week',
    monthly: 'This month',
  },
  upgrade: {
    tip_1: 'Upgrade needed',
    tip_2: 'Your support will inspire the developer and make LittleStar better 😉',
    btn: 'Upgrade account',
  },
}
